
import { defineComponent } from "vue";
import { mapActions, mapState } from "vuex";

export default defineComponent({
  name: "TeacherCard",
  props: ["firstname", "lastname", "image", "userId"],
  computed: { ...mapState(["isAdmin"]) },
  methods: {
    ...mapActions(["deleteTeacher"]),
    handleDelete(userId: string) {
      this.deleteTeacher(userId);
    },
  },
});
